import React, { useRef, memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

/**
 * @typedef {object} FilePickerProps
 * @property {boolean} [multiple] Default value is **false**
 * @property {(files: FileList) => void} [onChange]
 */

/**
 * @type {React.FC<
 *   FilePickerProps & import('react-native').TouchableOpacityProps
 * >}
 */
export const FilePicker = memo(
  ({ multiple = false, onChange, children, style, disabled = false }) => {
    const fileInputRef = useRef(null);

    const _onPress = useCallback(() => {
      fileInputRef.current.click();
    }, []);

    const _onChange = useCallback(
      (e) => {
        const { target: { files } = {} } = e;
        files.length > 0 && onChange && onChange(files);
        e.target.value = null;
      },
      [onChange]
    );

    return (
      <TouchableOpacity
        disabled={disabled || !onChange}
        activeOpacity={0.7}
        style={style}
        onPress={_onPress}
      >
        {children}
        <input
          ref={fileInputRef}
          style={styles_input}
          type="file"
          onChange={_onChange}
          {...{ multiple }}
        />
      </TouchableOpacity>
    );
  }
);

const styles_input = {
  display: 'none',
};
